<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <h1 class="title is-5">{{ $t('routes.createResource') }}</h1>
      <div class="form-container">
        <ResourceForm @save="save"></ResourceForm>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import DashboardLayout from '@/components/DashboardLayout'
  import ResourceForm from "@/components/ResourceForm"

  export default {
    components: {
      ResourceForm,
      DashboardLayout,
    },
    methods: {
      save(payload) {
        this.$store.dispatch('Moderator/create', {actionType: 'resources', payload}).then(() =>
          this.$router.push({ name: 'manageResources'}))
      }
    },
    mounted() {
      this.$store.dispatch('Moderator/getRelations', {actionType: 'resources'})
    },
    computed: {
      breadcrumbs() {
        return [
          {name: 'manageResources', path: 'manageResources'},
          {name: 'createResource'}
        ]
      }
    }
  }
</script>